import WebNavigation from './WebNavigation';

export default WebNavigation;


// WEBPACK FOOTER //
// ./src/components/WebNavigations/index.tsx